import cn from 'clsx';
import { FC } from 'react';

import s from './DefaultSummaryBox.module.scss';

interface SummaryBoxItemModel {
  title: string;
  amount: string;
}

export interface DefaultSummaryBoxProps {
  summaryText?: string;
  summaryItems?: SummaryBoxItemModel[];
}

const DefaultSummaryBox: FC<React.PropsWithChildren<React.PropsWithChildren<DefaultSummaryBoxProps>>> = ({ summaryItems, summaryText }) => {
  return (
    <div className={s.wrap}>
      {summaryText && <p className={s.summary_text}>{summaryText}</p>}
      {summaryItems?.map((item) => (
        <p key={item.title} className={cn(s.summary_item, s.summary_text)}>
          <span className={s.item_title}>{item.title}</span>
          <span className={s.item_amount}>{item.amount}</span>
        </p>
      ))}
    </div>
  );
};

export default DefaultSummaryBox;
